<template>
  <div class="column2-container">
    <TrajectoryDiagram :trajectory="trajectory"></TrajectoryDiagram>
    <Order :orderList="order"></Order>
    <MapHot></MapHot>
  </div>
</template>

<script>
import { getTrajectoryHeat } from '../../api/colunm2'
import TrajectoryDiagram from './components/TrajectoryDiagram.vue'
import Order from './components/Order.vue'
import MapHot from './components/MapHot.vue'
export default {
  components: {
    TrajectoryDiagram,
    Order,
    MapHot
  },

  data () {
    return {
      trajectory: [],
      order: []
    }
  },

  created () {
    this.getData()
  },

  methods: {
    getData () {
      getTrajectoryHeat().then(res => {
        // this.trajectory = res.writeInVos.splice(0, Math.floor(Math.random() * (15 - 5 + 1) + 5))
        this.trajectory = res.writeInVos
        this.order = []
        setTimeout(() => {
          this.order = res.goodsOrders
        }, 1000 * 2)
        this.timer && clearInterval(this.timer)
        this.timer = setTimeout(this.getData, 1000 * 10)
      })
    },
  }
}
</script>

<style lang="less" scoped>
.column2-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 639px;
  margin: 0 40px;
  // background-color: yellow;
}
</style>